import { createFileRoute } from '@tanstack/react-router';
import { GreetLoader } from '@/components/brand/GreetLoader';

// The app's main loader on light and dark, at the sizes we use.
export const Route = createFileRoute('/dev/loader-preview')({
  component: LoaderPreview,
  head: () => ({ meta: [{ title: 'Loader · greet' }] }),
});

function LoaderPreview() {
  return (
    <div className="grid min-h-screen grid-cols-2">
      <div className="flex flex-col items-center justify-center gap-10 bg-white text-neutral-900">
        <GreetLoader />
        <GreetLoader size={32} />
      </div>
      <div className="dark flex flex-col items-center justify-center gap-10 bg-neutral-950 text-white">
        <GreetLoader />
        <GreetLoader size={32} />
      </div>
    </div>
  );
}
